// Status
export const APP_STATE = {
    INITIALIZING: 'INITIALIZING',
    INITIALIZED: 'INITIALIZED'
};

// Action type
export const INITIALIZE_SUCCESS = 'INITIALIZE_SUCCESS';
